import React from 'react'
import get from 'lodash/get'
import { useTranslation } from 'react-i18next'

import { Select } from 'components/forms'
import { useQuery } from 'components/graphql'
import { getCategoryProducts } from 'sections/category/gql'

const FixProdsSelect = ({ value, onChange, categoryId }) => {
	const [t] = useTranslation()
	const { data, queryField } = useQuery(getCategoryProducts, {
		variables: { id: categoryId }
	})
	const gridProducts = get(data, [queryField, 'gridProducts'], [])
	const arrIds = gridProducts.map(({ productId }) => productId)
	// Add required fields of Product to output if it Grid Product doesn't have duplicates
	const uniqueProducts = gridProducts.reduce((outArr, item, i, arr) => {
		if(i === arrIds.indexOf(item.productId)) {
			const { product: { id, name, code } } = item
			return [...outArr, { id, name, code, value: id, label: name }]
		}
		return outArr
	}, [])

	return(
		<Select
			noForm
			value={value}
			simpleValue={false}
			valueField='id'
			labelField='name'
			options={uniqueProducts}
			onChange={onChange}
			label={t('product_section.caption')} />
	)
}

export default FixProdsSelect
